// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3c146bcd","404":"56adad8e","498":"d6cc0702","787":"216d0173"}[chunkId] + ".chunk.js";
};